import {
  CreateTprmExternalQuestionnaire,
  DataRoomId,
  TprmExternalQuestionnaire,
  TprmExternalQuestionnaireId,
} from "../../Types";
import {invalidateQueries, q} from "../../state";
import {CURRENT_REGION} from "../../utils/region";
import jsonApi from "../jsonApi";

export async function create(
  externalQuestionnaire: CreateTprmExternalQuestionnaire,
): Promise<TprmExternalQuestionnaire> {
  const res = await jsonApi.post<TprmExternalQuestionnaire>(
    `/region/${CURRENT_REGION}/api/tprm/external_questionnaires`,
    externalQuestionnaire,
  );
  await invalidateQueries([q.tprm.dataRoomExternalQuestionnaires.filter(externalQuestionnaire.data_room_id)]);
  return res;
}

export async function get(externalQuestionnaireId: TprmExternalQuestionnaireId): Promise<TprmExternalQuestionnaire> {
  return jsonApi.get<TprmExternalQuestionnaire>(
    `/region/${CURRENT_REGION}/api/tprm/external_questionnaires/${externalQuestionnaireId}`,
  );
}

export async function delete_(
  externalQuestionnaireId: TprmExternalQuestionnaireId,
  dataRoomId: DataRoomId,
): Promise<void> {
  await jsonApi.delete_<TprmExternalQuestionnaire>(
    `/region/${CURRENT_REGION}/api/tprm/external_questionnaires/${externalQuestionnaireId}`,
  );
  await invalidateQueries([q.tprm.dataRoomExternalQuestionnaires.filter(dataRoomId)]);
}

export async function unlock(externalQuestionnaireId: TprmExternalQuestionnaireId): Promise<void> {
  await jsonApi.post(`/region/${CURRENT_REGION}/api/tprm/external_questionnaires/${externalQuestionnaireId}/unlock`);
  await invalidateQueries([q.tprm.externalQuestionnaire.filter(externalQuestionnaireId)]);
}

export async function lock(externalQuestionnaireId: TprmExternalQuestionnaireId): Promise<void> {
  await jsonApi.post(`/region/${CURRENT_REGION}/api/tprm/external_questionnaires/${externalQuestionnaireId}/lock`);
  await invalidateQueries([q.tprm.externalQuestionnaire.filter(externalQuestionnaireId)]);
}
